<template>
  <div id="customized-report-area">
    <div style="page-break-after: always">
      <CoverPageComponent
        :companyName="companyName"
        :companyLogo="companyLogo"
        :productType="productType"
        :reportDate="reportDate"
        :coverPage="coverPage"
      />
    </div>

    <template v-for="(content, i) in contents" :key="i">
      <div style="page-break-after: always">
        <div style="min-height: 95vh">
          <TableofContentsComponent
            :companyLogo="companyLogo"
            :productType="productType"
            :reportDate="reportDate"
            :contents="content"
            :pages="pages.length > 0 ? pages[i] : []"
          />
        </div>
        <customized-report-footer :reportDate="reportYear" />
      </div>
    </template>

    <div v-if="overview !== null" style="page-break-after: always">
      <div style="min-height: 95vh">
        <OverviewComponent
          :companyName="companyName"
          :companyLogo="companyLogo"
          :productType="productType"
          :reportDate="reportDate"
          :overview="overview"
        />
      </div>

      <customized-report-footer
        :pageNumber="overviewPageNumber"
        :reportDate="reportYear"
      />
    </div>

    <div v-if="hasTerms" style="page-break-after: always">
      <div style="min-height: 95vh">
        <TerminologyMethodologyComponent
          :productType="productType"
          :reportDate="reportDate"
        />
      </div>

      <customized-report-footer
        :pageNumber="terminolgyPageNumber"
        :reportDate="reportYear"
      />
    </div>

    <template
      v-for="(dashboard, dashbordIndex) in dashboards"
      :key="dashbordIndex"
    >
      <div style="page-break-after: always">
        <div style="min-height: 95vh">
          <YearEndOutlookComponent
            :companyLogo="companyLogo"
            :productType="productType"
            :reportDate="reportDate"
            :dashboard="dashboard"
            :indicatorPageNumbers="dashboardIndicatorPageNumbers[dashbordIndex]"
          />
        </div>
        <customized-report-footer
          :pageNumber="dashboardPageNumber[dashbordIndex]"
          :reportDate="reportYear"
        />
      </div>
    </template>

    <template v-for="(indicator, i) in indicators" :key="i">
      <div>
        <div style="page-break-after: always">
          <div style="min-height: 95vh">
            <IndicatorsComponent
              :companyLogo="companyLogo"
              :productType="productType"
              :reportDate="reportDate"
              :indicator="indicator"
              :index="i"
            />
          </div>
          <customized-report-footer
            :pageNumber="indicatorPageNumbers[i]"
            :reportDate="reportYear"
          />
        </div>

        <template
          v-if="
            indicator.DashboardTable !== null &&
            indicator.DashboardTable.Rows.length > 0 &&
            indicator.DashboardTable.Rows[0].RowData.length > 16
          "
        >
          <div style="page-break-after: always">
            <div style="min-height: 95vh">
              <indicator-long-forecast-component
                :companyLogo="companyLogo"
                :productType="productType"
                :reportDate="reportDate"
                :indicator="indicator"
                :index="i"
              />
            </div>
            <customized-report-footer
              :pageNumber="indicatorPageNumbers[i] + 1"
              :reportDate="reportYear"
            />
          </div>
        </template>
      </div>
    </template>

    <div v-if="leadingIndicator !== null" style="page-break-after: always">
      <div style="min-height: 95vh">
        <LeadingIndicatorsComponent
          :companyLogo="companyLogo"
          :productType="productType"
          :reportDate="reportDate"
          :leadingIndicator="leadingIndicator"
        />
      </div>
      <customized-report-footer
        :pageNumber="leadingIndicatorPageNumber"
        :reportDate="reportYear"
      />
    </div>

    <template v-for="(definition, i) in indicatorDefinitions" :key="i">
      <div
        :style="
          i === indicatorDefinitions.length - 1 && !hasObjectives
            ? ''
            : 'page-break-after:always;'
        "
      >
        <div style="min-height: 95vh">
          <IndicatorDefinitionsComponent
            :companyLogo="companyLogo"
            :productType="productType"
            :reportDate="reportDate"
            :pageTitle="definition.pageTitle"
            :indicatorDefinitions="definition.definitions"
          />
        </div>
        <customized-report-footer
          :pageNumber="definitionPageNumbers[i]"
          :reportDate="reportYear"
        />
      </div>
    </template>

    <div v-if="hasObjectives" style="min-height: 100vh">
      <div style="min-height: 95vh">
        <ManagementObjectivesComponent
          :companyLogo="companyLogo"
          :productType="productType"
          :reportDate="reportDate"
        />
      </div>
      <customized-report-footer
        :pageNumber="managementObjectivesPageNumber"
        :reportDate="reportYear"
      />
    </div>
  </div>
</template>
<script>
  import CoverPageComponent from '~/components/report/modules/live-report/customized-report/CoverPageComponent.vue';
  import TableofContentsComponent from '~/components/report/modules/live-report/customized-report/TableofContentsComponent.vue';
  import OverviewComponent from '~/components/report/modules/live-report/customized-report/OverviewComponent.vue';
  import TerminologyMethodologyComponent from '~/components/report/modules/live-report/customized-report/TerminologyMethodologyComponent.vue';
  import YearEndOutlookComponent from '~/components/report/modules/live-report/customized-report/YearEndOutlookComponent.vue';
  import IndicatorsComponent from '~/components/report/modules/live-report/customized-report/IndicatorsComponent.vue';
  import IndicatorLongForecastComponent from '~/components/report/modules/live-report/customized-report/IndicatorLongForecastComponent.vue';
  import LeadingIndicatorsComponent from '~/components/report/modules/live-report/customized-report/LeadingIndicatorsComponent.vue';
  import IndicatorDefinitionsComponent from '~/components/report/modules/live-report/customized-report/IndicatorDefinitionsComponent.vue';
  import ManagementObjectivesComponent from '~/components/report/modules/live-report/customized-report/ManagementObjectivesComponent.vue';
  import CRFooterComponent from '~/components/report/modules/live-report/customized-report/CRFooterComponent.vue';

  export default {
    name: 'CustomizedReportPDFComponent',
    components: {
      CoverPageComponent,
      TableofContentsComponent,
      OverviewComponent,
      TerminologyMethodologyComponent,
      YearEndOutlookComponent,
      IndicatorsComponent,
      LeadingIndicatorsComponent,
      IndicatorDefinitionsComponent,
      ManagementObjectivesComponent,
      CRFooterComponent,
      IndicatorLongForecastComponent,
    },
    props: {
      companyName: String,
      companyLogo: String,
      reportDate: String,
      reportYear: String,
      productType: String,
      coverPage: Object,
      contents: Array,
      overview: Object,
      dashboards: Array,
      hasTerms: Boolean,
      indicators: Array,
      leadingIndicator: Object,
      hasObjectives: Boolean,
      indicatorDefinitions: Array,
    },
    data: function () {
      return {
        overviewPageNumber: 0,
        terminolgyPageNumber: 0,
        dashboardPageNumber: [],
        indicatorPageNumbers: [],
        dashboardIndicatorPageNumbers: [],
        leadingIndicatorPageNumber: 0,
        definitionPageNumbers: [],
        managementObjectivesPageNumber: 0,
        addPages: 0,
        pages: [],
      };
    },
    mounted() {
      this.setPageNumbers();
    },
    methods: {
      setPageNumbers() {
        this.overviewPageNumber = this.overview !== null ? 1 : 0;
        this.terminolgyPageNumber =
          this.hasTerms && this.overview !== null ? 2 : 1;

        //determine first dashboard page
        let firstDashboardPage =
          this.overview === null && !this.hasTerms
            ? 1
            : (this.overview === null && this.hasTerms) ||
                (this.overview !== null && !this.hasTerms)
              ? 2
              : 3;

        // if more than one dashboard page, loop and add
        if (this.dashboards.length > 0) {
          for (let index = 0; index < this.dashboards.length; index++) {
            this.dashboardPageNumber.push(firstDashboardPage + index);

            if (index > 0) {
              this.addPages = this.addPages + 1;
            }
          }
        }

        let tempDashboardIndicatorPageNumbers = [];
        for (let i = 0; i < this.indicators.length; i++) {
          const indicator = this.indicators[i];

          this.indicatorPageNumbers.push(
            // this.hasTerms && this.overview !== null ? 4 + i + this.addPages : 3 + i + this.addPages
            this.overview === null && !this.hasTerms
              ? 2 + i + this.addPages
              : (this.overview === null && this.hasTerms) ||
                  (this.overview !== null && !this.hasTerms)
                ? 3 + i + this.addPages
                : 4 + i + this.addPages
          );

          //add 1 if indicator is pushed to second page
          if (
            indicator.DashboardTable !== null &&
            indicator.DashboardTable.Rows.length > 0 &&
            indicator.DashboardTable.Rows[0].RowData.length > 16
          ) {
            this.addPages = this.addPages + 1;
          }

          //build indicator page numbers for dashboard table
          tempDashboardIndicatorPageNumbers.push(
            this.overview === null && !this.hasTerms
              ? 2 + i + this.addPages
              : (this.overview === null && this.hasTerms) ||
                  (this.overview !== null && !this.hasTerms)
                ? 3 + i + this.addPages
                : 4 + i + this.addPages
          );

          if (
            tempDashboardIndicatorPageNumbers.length >= 10 ||
            i === this.indicators.length - 1
          ) {
            this.dashboardIndicatorPageNumbers.push(
              tempDashboardIndicatorPageNumbers
            );

            // reset
            tempDashboardIndicatorPageNumbers = [];
          }
        }

        this.leadingIndicatorPageNumber =
          this.overview === null && !this.hasTerms
            ? 2 + this.indicators.length + this.addPages
            : (this.overview === null && this.hasTerms) ||
                (this.overview !== null && !this.hasTerms)
              ? 3 + this.indicators.length + this.addPages
              : 4 + this.indicators.length + this.addPages;

        for (let i = 0; i < this.indicatorDefinitions.length; i++) {
          this.definitionPageNumbers.push(
            this.overview === null &&
              !this.hasTerms &&
              this.leadingIndicator === null
              ? 2 + this.indicators.length + i + this.addPages
              : (this.overview === null &&
                    this.hasTerms &&
                    this.leadingIndicator === null) ||
                  (this.overview !== null &&
                    !this.hasTerms &&
                    this.leadingIndicator === null) ||
                  (this.overview === null &&
                    !this.hasTerms &&
                    this.leadingIndicator !== null)
                ? 3 + this.indicators.length + i + this.addPages
                : (this.overview !== null &&
                      this.hasTerms &&
                      this.leadingIndicator === null) ||
                    (this.overview === null &&
                      this.hasTerms &&
                      this.leadingIndicator !== null) ||
                    (this.overview !== null &&
                      !this.hasTerms &&
                      this.leadingIndicator !== null)
                  ? 4 + this.indicators.length + i + this.addPages
                  : 5 + this.indicators.length + i + this.addPages
          );
        }

        this.managementObjectivesPageNumber =
          this.overview === null &&
          !this.hasTerms &&
          this.leadingIndicator === null
            ? 2 +
              this.indicators.length +
              this.indicatorDefinitions.length +
              this.addPages
            : (this.overview === null &&
                  this.hasTerms &&
                  this.leadingIndicator === null) ||
                (this.overview !== null &&
                  !this.hasTerms &&
                  this.leadingIndicator === null) ||
                (this.overview === null &&
                  !this.hasTerms &&
                  this.leadingIndicator !== null)
              ? 3 +
                this.indicators.length +
                this.indicatorDefinitions.length +
                this.addPages
              : (this.overview !== null &&
                    this.hasTerms &&
                    this.leadingIndicator === null) ||
                  (this.overview === null &&
                    this.hasTerms &&
                    this.leadingIndicator !== null) ||
                  (this.overview !== null &&
                    !this.hasTerms &&
                    this.leadingIndicator !== null)
                ? 4 +
                  this.indicators.length +
                  this.indicatorDefinitions.length +
                  this.addPages
                : 5 +
                  this.indicators.length +
                  this.indicatorDefinitions.length +
                  this.addPages;

        //push to pages array
        var pages = [];
        if (this.overview !== null) {
          pages.push(this.overviewPageNumber);
        }

        if (this.hasTerms) {
          pages.push(this.terminolgyPageNumber);
        }

        // pages.push(this.dashboardPageNumber);

        // just push first page
        if (this.dashboardPageNumber.length > 0) {
          pages.push(this.dashboardPageNumber[0]);
        }

        for (let i = 0; i < this.indicatorPageNumbers.length; i++) {
          const pageNumber = this.indicatorPageNumbers[i];

          pages.push(pageNumber);
        }

        if (this.leadingIndicator !== null) {
          pages.push(this.leadingIndicatorPageNumber);
        }

        if (this.definitionPageNumbers.length > 0) {
          pages.push(this.definitionPageNumbers[0]);
        }

        if (this.hasObjectives) {
          pages.push(this.managementObjectivesPageNumber);
        }

        if (pages.length > 13) {
          while (pages.length > 13) {
            let pageGroup = pages.slice(0, 13);
            this.pages.push(pageGroup);
            pages.splice(0, 13);
          }
        }

        this.pages.push(pages);
      },
    },
  };
</script>
